module.exports = __webpack_public_path__ + "img/map.17d67659.jpg";